import { render } from "./CrearPaciente.vue?vue&type=template&id=57f8f8dd&scoped=true"
import script from "./CrearPaciente.vue?vue&type=script&lang=js"
export * from "./CrearPaciente.vue?vue&type=script&lang=js"

import "./CrearPaciente.vue?vue&type=style&index=0&id=57f8f8dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f8f8dd"]])

export default __exports__